var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4473 0.00146484C16.7923 0.00167444 17.0723 0.281416 17.0723 0.626465V1.25146H18.3223C19.7028 1.25167 20.8223 2.37088 20.8223 3.75146V17.5015C20.822 18.8818 19.7026 20.0013 18.3223 20.0015H3.32227C1.94171 20.0015 0.822519 18.882 0.822266 17.5015V3.75146C0.822266 2.37075 1.94155 1.25146 3.32227 1.25146H4.57227V0.626465C4.57227 0.281287 4.85209 0.00146484 5.19727 0.00146484C5.54227 0.00167444 5.82227 0.281416 5.82227 0.626465V1.25146H15.8223V0.626465C15.8223 0.281287 16.1021 0.00146484 16.4473 0.00146484ZM4.00391 3.75146C3.62735 3.75146 3.32227 4.03129 3.32227 4.37646V5.62646C3.32254 5.97143 3.62752 6.25146 4.00391 6.25146H17.6396C18.016 6.25146 18.322 5.97143 18.3223 5.62646V4.37646C18.3223 4.03129 18.0162 3.75146 17.6396 3.75146H4.00391Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParents);
export default __webpack_public_path__ + "static/media/parents.b7709b07fa1c5614e6c349f469022119.svg";
export { ForwardRef as ReactComponent };